import React, { useState } from 'react';

const Tab = (props: any) => {

    if (props.isSelected) {
        return (
          <div>
            {props.children }
          </div>
        );
      }
      return null;
    }


export default Tab;